/**
 * Where the published legal documents live.
 *
 * One place, because these links appear beside a TICK on forms people are
 * part-way through filling in, and they must open in a NEW TAB rather than
 * routing: a route change unmounts the form and loses everything typed, so
 * reading a document you are being asked to accept would cost you the sign-up.
 * That rules out router-link, which leaves a plain href needing a real path.
 *
 * Matches the route in pages/legal/[type].vue.
 *
 * House style: imported explicitly, never auto-imported.
 */
export const LEGAL_DOCUMENTS = Object.freeze({terms: 'terms', privacy: 'privacy'});

export function legalHref(type) {
  return `/legal/${LEGAL_DOCUMENTS[type] ?? LEGAL_DOCUMENTS.terms}`;
}

/**
 * Force every anchor in authored HTML to open in a new tab.
 *
 * Console-authored prompt copy links to the legal documents, and a prompt is
 * something someone is part-way through answering: a link that routes unmounts
 * the form and loses the answers. `rel` travels with it, because
 * target="_blank" alone hands the opened page a live reference back to this one.
 *
 * Anchors that already declare a target are left alone — an author who set one
 * meant it, and blindly prepending a second would leave two on the tag.
 */
export function openLinksInNewTab(html) {
  return (html ?? '').replace(/<a\b([^>]*)>/gi, (tag, attrs) =>
    /\btarget\s*=/i.test(attrs) ? tag : `<a target="_blank" rel="noopener noreferrer"${attrs}>`);
}
